/** @flow */

import React from "react";
import { localize } from "redux-i18n";
import { ColumnsContainer } from "@components";
import { formatDate } from "@transformers/date";

type Props = $Exact<{
  data: Object,
  schema: ?Object,
  ...PropsFromLocalize,
}>;

export class StepFiltersView extends React.Component<Props> {
  get schema(): Object {
    return this.props.schema || {};
  }

  get monitoringLevelsOptions() {
    return this.schema.properties
      ? this.schema.properties.monitoringLevels.items.properties.id.oneOf
      : [];
  }

  get alertsTriggeredOptions() {
    return this.schema.properties
      ? this.schema.properties.alertsTriggered.items.properties.id.oneOf
      : [];
  }

  get statusesOptions() {
    return this.schema.properties.statuses.items.oneOf || [];
  }

  get staffGroupsOptions() {
    return this.schema.properties
      ? this.schema.properties.staffGroups.items.properties.id.oneOf
      : [];
  }

  get filtersOptions() {
    return [
      {
        columns: [
          {
            data: [
              [
                this.props.t("REPORT_FILTER_DATE_RANGE"),
                this.props.data.dateRange
                  ? this.props.t(this.props.data.dateRange)
                  : this.props.t("CUSTOM"),
              ],
              [
                this.props.t("MONITORING_LEVEL"),
                this.props.data.monitoringLevels
                  ? this.props.data.monitoringLevels
                      .map(
                        d =>
                          (this.monitoringLevelsOptions.find(o => o.const === d.id) || {}).title ||
                          "",
                      )
                      .join(", ")
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("STAFF_GROUP"),
                this.props.data.staffGroups
                  ? this.props.data.staffGroups
                      .map(
                        d =>
                          (this.staffGroupsOptions.find(o => o.const === d.id) || {}).title || "",
                      )
                      .join(", ")
                  : this.props.t("ALL"),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("FROM_DATE"),
                this.props.data.fromDate
                  ? formatDate(this.props.data.fromDate)
                  : this.props.t("N/A"),
              ],
              [
                this.props.t("ALERTS_TRIGGERED"),
                this.props.data.alertsTriggered
                  ? this.props.data.alertsTriggered
                      .map(
                        d =>
                          (this.alertsTriggeredOptions.find(o => o.const === d.id) || {}).title ||
                          "",
                      )
                      .join(", ")
                  : this.props.t("ALL"),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("TO_DATE"),
                this.props.data.toDate ? formatDate(this.props.data.toDate) : this.props.t("N/A"),
              ],
              [
                this.props.t("CURRENT_STATUS"),
                this.props.data.statuses
                  ? this.props.data.statuses
                      .map(d => (this.statusesOptions.find(o => o.const === d) || {}).title || "")
                      .join(", ")
                  : this.props.t("ALL"),
              ],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer className="w-100" rows={this.filtersOptions} />;
  }
}

export default localize()(StepFiltersView);
